import React, { useState, useEffect } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import './FleetEditModal.css'
import { addEscapeKeyListener } from '../../utils/common-methods'

const FleetEditModal = ({ vehicle, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    chassis_number: '',
    motor_number: '',
    location: '',
    type: '',
    charging_type: '',
    isActive: true
  })

  useEffect(() => {
    if (vehicle) {
      setFormData({
        chassis_number: vehicle.chassis_number || '',
        motor_number: vehicle.motor_number || '',
        location: vehicle.location || '',
        type: vehicle.type || '',
        charging_type: vehicle.charging_type || '',
        isActive: vehicle.isActive !== false
      })
    }
  }, [vehicle])

  useEffect(() => {
    const removeListener = addEscapeKeyListener(() => {
      onClose()
    })
    return () => {
      removeListener()
    }
  }, [onClose])

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
  }

  const handleToggleActive = () => {
    setFormData(prev => ({ ...prev, isActive: !prev.isActive }))
  }

  const handleSubmit = () => {
    if (!formData.chassis_number.trim()) {
      return
    }
    onSubmit({
      _id: vehicle._id,
      ...formData
    })
  }

  return (
    <Modal
      show={!!vehicle}
      onHide={onClose}
      id='fleetVehicleEditModal'
      centered
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Body style={{ padding: '30px' }}>
        <div style={{ textAlign: 'center', marginTop: '5px', color: '#1F2A5D' }}>
          <strong>Edit Vehicle</strong>
        </div>
        <div className='fleet-edit-form'>
          <div className='fleet-edit-row'>
            <label>Vehicle No.</label>
            <span>{vehicle?.registration_number}</span>
          </div>
          <div className='fleet-edit-row'>
            <label>OEM & Model</label>
            <span>{`${vehicle?.oem || ''} ${vehicle?.model || ''}`}</span>
          </div>
          <Form.Group className='fleet-edit-row'>
            <Form.Label>Chassis No. <span className='text-danger'>*</span></Form.Label>
            <Form.Control
              type='text'
              name='chassis_number'
              value={formData.chassis_number}
              onChange={handleChange}
              placeholder='Enter chassis number'
              size='sm'
            />
          </Form.Group>
          <Form.Group className='fleet-edit-row'>
            <Form.Label>Motor No.</Form.Label>
            <Form.Control
              type='text'
              name='motor_number'
              value={formData.motor_number}
              onChange={handleChange}
              placeholder='Enter motor number'
              size='sm'
            />
          </Form.Group>
          <Form.Group className='fleet-edit-row'>
            <Form.Label>Location</Form.Label>
            <Form.Control
              type='text'
              name='location'
              value={formData.location}
              onChange={handleChange}
              placeholder='Enter location'
              size='sm'
            />
          </Form.Group>
          <Form.Group className='fleet-edit-row'>
            <Form.Label>Type</Form.Label>
            <Form.Control
              type='text'
              name='type'
              value={formData.type}
              onChange={handleChange}
              placeholder='Enter type'
              size='sm'
            />
          </Form.Group>
          <Form.Group className='fleet-edit-row'>
            <Form.Label>Charging Type</Form.Label>
            <Form.Control
              type='text'
              name='charging_type'
              value={formData.charging_type}
              onChange={handleChange}
              placeholder='Enter charging type'
              size='sm'
            />
          </Form.Group>
          <div className='fleet-edit-row fleet-edit-toggle-row'>
            <label>Active Status</label>
            <div className='fleet-edit-toggle' onClick={handleToggleActive}>
              <div className={`fleet-toggle-switch ${formData.isActive ? 'active' : 'inactive'}`}>
                <div className='fleet-toggle-knob'></div>
              </div>
              <span className={formData.isActive ? 'text-success' : 'text-danger'}>
                {formData.isActive ? 'Active' : 'Inactive'}
              </span>
            </div>
          </div>
        </div>
        <div className='text-center' style={{ marginTop: '20px' }}>
          <Button
            type='submit'
            variant='primary'
            className='small-button'
            id='submitButtonEditVehicle'
            onClick={handleSubmit}
          >
            Save Changes
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  )
}

export default FleetEditModal
